import { Box, Typography } from '@mui/material';
import EmptySummary from '../../../../assets/images/empty-summary.svg';

type Props = {
  title: string;
  subtitles: string[];
};

export const BlankState = ({ title, subtitles = [] }: Props) => {
  return (
    <Box sx={{ width: 1, p: 4 }}>
      <Box sx={{ textAlign: 'center', maxWidth: '32rem', margin: 'auto' }}>
        <EmptySummary />
        <Typography sx={{ fontWeight: 500, mt: 1.5 }}>{title}</Typography>
        {subtitles.map((s, index) => (
          <Typography key={index} variant="body2" sx={{ mt: 1.5 }}>
            {s}
          </Typography>
        ))}
      </Box>
    </Box>
  );
};
